import { clearRules } from './component-rules';

export async function clearComponentStyling(fRange: any): Promise<void> {
  fRange.setBackgroundColor(null);
  await fRange.clearCommentsAsync();
  fRange.setNumberFormat(null);
  clearRules(fRange);
  fRange.breakApart();
  fRange.setCustomMetaData(null);
}

// Formula wins over value so a link survives a read/write round-trip. Never undefined, so
// callers can tell "nothing was captured" from "the cell was empty".
export function cellContent(fWorksheet: any, row: number, col: number): any {
  const cell = fWorksheet.getRange(row, col);
  return (cell.getFormula() || cell.getValue()) ?? null;
}

export async function deleteComponent(fRange: any): Promise<void> {
  fRange.clear({ contentsOnly: true });
  await clearComponentStyling(fRange);
}
